<abbr
  *cxFeature="'a11yRequiredAsterisks'"
  class="text-decoration-none required-asterisk"
  aria-hidden="true"
  title="{{ titleTranslation! | cxTranslate }}"
  >*</abbr
>
